// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.rule-popup[data-v-1e9d4a14] {\n  display: none;\n}\n.is-active[data-v-1e9d4a14] {\n  display: block;\n}\n", ""]);
// Exports
module.exports = exports;
